import LoginForm from "@/components/auth/LoginForm";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card"; 

const Login = () => {
  return (
    <Card className="w-[90%] lg:w-[70%]">
      <CardHeader>
        <CardTitle className="text-2xl font-bold text-center mb-5">
          Login 
        </CardTitle>
      </CardHeader>
      <CardContent>
        <LoginForm />
      </CardContent>
    </Card>
  );
};

export default Login;
